module.exports = __webpack_public_path__ + "static/media/request.bf584d9a.svg";